/**
 * Constantes e valores compartilhados do projeto
 */

// Regex patterns
export const REGEX_PATTERNS = {
  PHONE: /^[0-9]{2}[0-9]{5}[0-9]{4}$/,
  ZIP_CODE: /^[0-9]{5}[0-9]{3}$/,
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  CPF: /^[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}$/,
  CNPJ: /^[0-9]{2}\.[0-9]{3}\.[0-9]{3}\/[0-9]{4}-[0-9]{2}$/,
};

// Base URL da API do comprador (use REACT_APP_API_CUSTOMER_URL para desenvolvimento local)
const API_CUSTOMER_BASE = process.env.REACT_APP_API_CUSTOMER_URL || "https://matrixterra.com.br/ws/customer";
const API_WS_BASE = process.env.REACT_APP_API_WS_URL || "https://matrixterra.com.br/ws";

// URLs da API
export const API_URLS = {
  BASE: API_CUSTOMER_BASE,
  LOGIN: `${API_CUSTOMER_BASE}/login.php`,
  PRODUCTS: `${API_CUSTOMER_BASE}/products.php`,
  UPDATE_CART: `${API_CUSTOMER_BASE}/update_cart.php`,
  USER_CART: `${API_CUSTOMER_BASE}/user_cart.php`,
  MY_ACCOUNT: `${API_CUSTOMER_BASE}/my_account.php`,
  ALL_MEMBERS: `${API_CUSTOMER_BASE}/all_members_of_company.php`,
  COMPANY_DETAILS: `${API_CUSTOMER_BASE}/Details Companies/company_details.php`,
  PAYMENT_METHODS: `${API_CUSTOMER_BASE}/get_payment_methods.php`,
  GET_USER_INFO: `${API_CUSTOMER_BASE}/get_user_important_info.php`,
  GENERATE_PDF: `${API_CUSTOMER_BASE}/generate_order_pdf.php`,
  // Relatório de pedidos (PDF) — implementar no backend
  // Esperado: retorna application/pdf
  // Sugestão: aceitar POST com filtros (token, date_from, date_to, buyer_name, company_name)
  ORDERS_REPORT_PDF: `${API_CUSTOMER_BASE}/orders_report_pdf.php`,
  // Comprador (master): detalhes + pedidos + relatório em PDF — implementar no backend
  BUYER_DETAILS: `${API_CUSTOMER_BASE}/buyer_details.php`,
  BUYER_ORDERS: `${API_CUSTOMER_BASE}/buyer_orders.php`,
  BUYER_ORDERS_REPORT_PDF: `${API_CUSTOMER_BASE}/buyer_orders_report_pdf.php`,
  FINALIZE_CART: `${API_CUSTOMER_BASE}/finalize_cart.php`,
  GET_USER_CART_ID: `${API_CUSTOMER_BASE}/get_user_cart_id.php`,
  STATUS_ORDER_LIST: `${API_CUSTOMER_BASE}/status_order_list.php`,
  MAIN_CONTACT: `${API_WS_BASE}/main_contact.php`,
  PRODUCTS_CATEGORY: `${API_CUSTOMER_BASE}/products_category.php`,
  TERMS: {
    DOCUMENT: `${API_CUSTOMER_BASE}/terms.php?action=document&area=compras`,
    STATUS: (userId) => `${API_CUSTOMER_BASE}/terms.php?action=status&user_id=${userId}`,
    ACCEPT: `${API_CUSTOMER_BASE}/terms.php`,
  },
};

// Configurações de Toast
export const TOAST_CONFIG = {
  POSITION: "bottom-center",
  DURATION: 3000,
};

// Headers HTTP padrão
export const DEFAULT_HEADERS = {
  JSON: {
    "Content-Type": "application/json",
  },
  JSON_WITH_CORS: {
    "Content-Type": "application/json",
    "Access-Control-Request-Method": "application/postscript",
  },
};

// WhatsApp padrão
export const DEFAULT_WHATSAPP = "5551985530391";

// Cores padrão
export const COLORS = {
  PRIMARY: "#EC1F25",
  SECONDARY: "#071C1F",
  BLACK: "#000",
  WHITE: "#fff",
};

// Tamanhos padrão
export const SIZES = {
  LOADER_HEIGHT: "600px",
  PRODUCT_IMAGE_HEIGHT: "250px",
  PRODUCT_DETAIL_IMAGE_HEIGHT: "500px",
};

// URLs do site
export const SITE_URLS = {
  BASE: "https://matrixterra.com.br",
  PRODUCT_DETAIL: (id) => `https://matrixterra.com.br/produto/${id}`,
  PRODUCTS_CATEGORY: `${API_CUSTOMER_BASE}/products_category.php`,
  DETAILS_ORDER: (id) => `${API_CUSTOMER_BASE}/details_order.php?id_order=${id}`,
  FORGOT_PASSWORD: {
    SEND_CODE: `${API_CUSTOMER_BASE}/forgotPassword/send-code-password-forgot.php`,
    CHECK_CODE: `${API_CUSTOMER_BASE}/forgotPassword/check-code-forgot-password.php`,
    UPDATE_PASSWORD: `${API_CUSTOMER_BASE}/forgotPassword/update-password.php`,
  },
  PASSWORD_CHANGE: {
    SEND_CODE: `${API_CUSTOMER_BASE}/password-change/send_code_password.php`,
  },
  ALL_MEMBERS: `${API_CUSTOMER_BASE}/all_members_of_company.php`,
  ALL_COMPANIES: `${API_CUSTOMER_BASE}/all_companies.php`,
};

// Informações de contato
export const CONTACT_INFO = {
  EMAIL: {
    ADMIN: "adm@matrixterra.com.br",
    SALES: "vendas@matrixterra.com.br",
    CONTACT: "contato@matrixterra.com.br",
  },
  PHONE: {
    SAC: "(51) 9 8553-0391",
    WHATSAPP: "5551985530391",
    FORMATTED: "(51) 9 8553-0391",
  },
};

// Timeouts e delays (em milissegundos)
export const TIMEOUTS = {
  TOKEN_EXPIRATION: 8 * 60 * 60 * 1000, // 8 horas
  CART_LOAD_DELAY: 100, // 100ms
  DEBOUNCE_DEFAULT: 1000, // 1 segundo
  TOAST_DURATION: 3000, // 3 segundos
  CAROUSEL_SPEED: 3000, // 3 segundos
  CAROUSEL_AUTOPLAY: 1000, // 1 segundo
};

// Dimensões e espaçamentos (em pixels)
export const DIMENSIONS = {
  SPACING: {
    SMALL: "50px",
    MEDIUM: "100px",
    LARGE: "150px",
  },
  IMAGE: {
    PRODUCT_HEIGHT: "250px",
    PRODUCT_DETAIL_HEIGHT: "500px",
  },
  FONT: {
    LARGE_ICON: "150px",
  },
};

// Chaves de localStorage
export const STORAGE_KEYS = {
  USER_DATA: "userData",
};

// Mensagens de loading
export const LOADING_MESSAGES = {
  PRODUCTS: "Carregando Produtos...",
  CATEGORIES: "Carregando categorias...",
  DEFAULT: "Carregando...",
  GENERIC: "Loading...",
};

// Valores padrão
export const DEFAULT_VALUES = {
  PRICE: 250.0,
  DEBOUNCE_DELAY: 1000,
};

